import { inject, makeEnvironmentProviders, provideAppInitializer, type EnvironmentProviders } from '@angular/core';
import { AuthContextService } from './auth-context.service';

export function provideAuthContext(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(AuthContextService).reconcileAuthType()),
  ]);
}
